import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { OktaAuth } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import { AlertProvider, LoadingProvider as BcrLoadingProvider } from "best-common-react";
import React, { useMemo } from "react";
import "video-react/dist/video-react.css";
import HttpInterceptor from "../clients/HttpInterceptor";
import { AuthProvider } from "./AuthContext";
import { DplAlertProvider } from "./DplAlertContext";
import { useDplTheme } from "./DplThemeContext";
import { LoadingProvider } from "./LoadingContext";
import { MetadataProvider } from "./MetadataContext";
import { SavedSearchProvider } from "./SavedSearchContext";
import { SiteAlertProvider } from "./SiteAlertContext";

const oktaConfig = window.MLBBest.envVariables.OKTA_CONFIG;

const Providers: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme } = useDplTheme();
  const oktaAuth = useMemo(() => new OktaAuth(oktaConfig), []);

  const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
    window.location.replace(originalUri);
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <AlertProvider defaultAlertCloseTimes={{ danger: 4000 }}>
          <SiteAlertProvider>
            {/* TODO: Update to player type when fixed in BCR for firefox */}
            <BcrLoadingProvider type="mlb" animated={true}>
              <LoadingProvider>
                <AuthProvider oktaAuth={oktaAuth}>
                  <HttpInterceptor>
                    <DplAlertProvider>
                      <MetadataProvider>
                        <SavedSearchProvider>
                          <ThemeProvider theme={theme}>{children}</ThemeProvider>
                        </SavedSearchProvider>
                      </MetadataProvider>
                    </DplAlertProvider>
                  </HttpInterceptor>
                </AuthProvider>
              </LoadingProvider>
            </BcrLoadingProvider>
          </SiteAlertProvider>
        </AlertProvider>
      </MuiPickersUtilsProvider>
    </Security>
  );
};

export default Providers;
